<template>
    <div class="card w-full px-3">
        <div class="flex justify-content-center align-content-center flex-wrap card-container h-screen w-full">
            <div class="flex surface-0 border-round-xl shadow-0 xl:shadow-6 md:shadow-6 sm:shadow-6 align-items-center justify-content-center">
                <div v-if="data" class="w-full max-w-30rem p-3">
                    <div>
                        <img class="w-full border-round-xl mb-3" 
                        :src="data.img">
                    </div>
                    <span class="block text-xl font-medium mb-3 line-height-2">
                        {{ data.title }}
                    </span>
                    <span class="block mb-3 line-height-2">
                        {{ data.description }}
                    </span>
                    <Button @click="go_tg(data.url, data.code)" :icon="data.icon" :label="data.button" icon-pos="right"
                        class="mt-2 w-full border-round-xl mb-3 border-0 bg-telegram" size="large" severity="info" />
                    <span v-if="true" class="field flex text-xs text-500 align-items-center justify-content-center w-full text-center">
                        Авторизация через Telegram безопасна и не требует ввода личных данных. Все операции защищены сквозным шифрованием, что обеспечивает высокий уровень безопасности ваших транзакций.
                    </span>
                </div>
                <div v-else class="w-full max-w-30rem p-3">
                    <span class="block mb-3">
                        Форма не найдена
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import Event from '@/assets/js/Event'
import forms from '@/assets/json/forms.json'
import { useCookies } from "vue3-cookies"
import FbConversion from '@/assets/js/classes/FbConversion.js'

export default {
    data() {
        return {
            data: null,
            utm: null,
            cookies: useCookies(),
        }
    },
    methods: {
        createUtmUrl(url){
            const old_utm = this.getUtm()
            if(!this.utm) this.utm = old_utm
            const fbclid = this.getFbclid()
            const yandexclid = this.getYandexclid()
            const gaClientId = this.getGaClientId()
            const utmUrl = this.helper.createUtmUrlSendpulse(url, this.utm, fbclid, yandexclid, gaClientId)
            return utmUrl
        },
        getUtm(){
            // читаем store, cookie, localstorage на наличие UTM меток
            const utm_store = this.$store.getters.StateUtm
            const utm_cookie = this.cookies.cookies.get("utm")
            const utm_localstorage = JSON.parse(localStorage.getItem('utm'))

            // записываем utm метки в переменные            
            let utm_source = null
            let utm_medium = null
            let utm_campaign = null
            let utm_term = null
            let utm_content = null
        
            // utm_source
            try { utm_source = utm_store.utm_source } catch{}
            if(!utm_source) try { utm_source = utm_cookie.utm_source } catch{}
            if(!utm_source) try { utm_source = utm_localstorage.utm_source } catch{}
            if(!utm_source) try { utm_source = null } catch{}

            // utm_medium
            try { utm_medium = utm_store.utm_medium } catch{}
            if(!utm_medium) try { utm_medium = utm_cookie.utm_medium } catch{}
            if(!utm_medium) try { utm_medium = utm_localstorage.utm_medium } catch{}
            if(!utm_medium) try { utm_medium = null } catch{}

            // utm_campaign
            try { utm_campaign = utm_store.utm_campaign } catch{}
            if(!utm_campaign) try { utm_campaign = utm_cookie.utm_campaign } catch{}
            if(!utm_campaign) try { utm_campaign = utm_localstorage.utm_campaign } catch{}
            if(!utm_campaign) try { utm_campaign = null } catch{}

            // utm_term
            try { utm_term = utm_store.utm_term } catch{}
            if(!utm_term) try { utm_term = utm_cookie.utm_term } catch{}
            if(!utm_term) try { utm_term = utm_localstorage.utm_term } catch{}
            if(!utm_term) try { utm_term = null } catch{}
           
            // utm_content
            try { utm_content = utm_store.utm_content } catch{}
            if(!utm_content) try { utm_content = utm_cookie.utm_content } catch{}
            if(!utm_content) try { utm_content = utm_localstorage.utm_content } catch{}
            if(!utm_content) try { utm_content = null } catch{}

            const utm = {
                utm_source: utm_source,
                utm_medium: utm_medium,
                utm_campaign: utm_campaign,
                utm_content: utm_content,
                utm_term: utm_term,
            }
            if(utm_source || utm_medium || utm_campaign || utm_content || utm_term){
                return utm
            } 
            return null
        },
        // получаем fbclid из url
        getFbclid(){    
            const url = this.helper.getUrl()
            if(!url) return null
            const fbclid = this.helper.getByParam(url, 'fbclid')
            if(!fbclid) return null
            const fbcWithParams = this.helper.formatFbpFbc(fbclid) 
            if(fbcWithParams) return fbcWithParams

            return null
        },
        getYandexclid(){    
            try {
                const yandexclid = this.$store.getters.StateYandexClientId
                if(!yandexclid) return null
                return yandexclid
            } catch { return null }
        },
        getGaClientId(){
            try {
                return this.helper.getGaClientId()
            } catch { return null }
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        go_tg(url, code=null){
            const utm_url = this.createUtmUrl(url)

            try{
                const fbConv = new FbConversion('subscribeTg')
                const fbp = this.getFbp
                const fbc = this.getFbc
                const url = this.getUrl
                const time = Math.floor(Date.now() / 1000)
                const userAgent = this.helper.getUserAgent()
                if(fbp)         fbConv.setFbp(fbp)
                if(fbc)         fbConv.setFbc(fbc)
                if(url)         fbConv.setUrl(url)
                if(time)        fbConv.setTime(time)
                if(userAgent)   fbConv.setUserAgent(userAgent)
                if(code)        fbConv.setSubscriptionId(code)
                const fbData =  fbConv.get()
                this.event.send('subscribeTg', fbData)
            } catch(e){ 
                console.log(e)
            }

            try{
                window.open(utm_url, '_blank')
            } catch(e){ 
                console.log(e)
            }
            return false
        },
        async loadForm(code) {
            const json = forms.find(item => item.code === code)
            this.data = json
        }
    },
    computed: {
        getFbp() { return this.helper.getFbp() },
        getFbc() { return this.helper.getFbc() },
        getUrl: function () { return this.helper.getUrl() },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this) 
    },
    async mounted() {
        const route = useRoute()
        this.utm = this.helper.getUtm()
        if(route.params.code){
            await this.loadForm(route.params.code)
        }

        // перезапуск скрипта чата с новым visitorId
        try {
            window.BrevoConversationsSetup = {
                startHidden: true,
                language: 'ru',
                colors: {
                    buttonText: '#5e7e4a', 
                    buttonBg: '#aeee83'
                },
                buttonSize: 50,
            }
            BrevoConversations('restart')
        } catch { }
    },
    
}
</script>

 

